import { render, staticRenderFns } from "./MarketplaceSettingsEdit.vue?vue&type=template&id=6d018a8c&scoped=true"
import script from "./MarketplaceSettingsEdit.vue?vue&type=script&lang=js"
export * from "./MarketplaceSettingsEdit.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceSettingsEdit.vue?vue&type=style&index=0&id=6d018a8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d018a8c",
  null
  
)

export default component.exports